import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Optional, Output } from '@angular/core';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { RoleData } from '../../stores/roles.store';

@Component({
    selector: 'ts-role-switchers',
    templateUrl: './role-switchers.component.html',
    styleUrls: ['./role-switchers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, MatSlideToggleModule, TranslateModule, MatProgressSpinnerModule, MatFormFieldModule]
})
export class RoleSwitchersComponent implements OnInit {
  @Input() options: RoleData[] = [];
  @Input() loading = true;
  @Optional() @Input() enabled: RoleData[] = [];

  @Output() enabledChange = new EventEmitter<RoleData[]>();
  @Output() granted = new EventEmitter<RoleData>();
  @Output() revoked = new EventEmitter<RoleData>();

  public ngOnInit(): void {
    this.enabledChange.emit(this.enabled);
  }

  public toggleRole(role: RoleData, event: MatSlideToggleChange) {
    event.checked ? this.grantRole(role) : this.removeRole(role);
    this.enabledChange.emit(this.enabled);
  }

  public isEnabled(role: RoleData): boolean {
    return this.enabled.some((item) => item.id === role.id);
  }

  private grantRole(role: RoleData) {
    this.enabled = [...this.enabled, role];
    this.granted.emit(role);
  }

  private removeRole(role: RoleData) {
    this.enabled = this.enabled.filter((item) => item.id !== role.id);
    this.revoked.emit(role);
  }
}
